const normalizeStatus = (status) => (status || '').toUpperCase();

const isFailedStatus = (status) => normalizeStatus(status) === 'FAILED';
const isRunningStatus = (status) => normalizeStatus(status) === 'RUNNING';
const isProcessingStatus = (status) => {
  const normalized = normalizeStatus(status);
  return normalized === 'PROCESSING' || normalized === 'BATCH_PROCESSING';
};
const isCompleteStatus = (status) => {
  const normalized = normalizeStatus(status);
  return normalized === 'COMPLETE' || normalized === 'COMPLETED';
};

const isCancelledStatus = (status) => normalizeStatus(status) === 'CANCELLED';

// Consider a report "in progress" if it's not failed and not complete
// This catches any intermediate status the backend might return
const isInProgressStatus = (status) => {
  const normalized = normalizeStatus(status);

  // Log any non-standard status for debugging
  const knownStatuses = [
    'RUNNING',
    'PROCESSING',
    'BATCH_PROCESSING',
    'PENDING',
    'IN_PROGRESS',
    'SUBMITTED',
    'STARTED',
    'FAILED',
    'COMPLETE',
    'COMPLETED'
  ];
  if (normalized && !knownStatuses.includes(normalized)) {
    console.warn('[reportHelpers] Unknown status detected:', normalized);
  }

  return !isFailedStatus(status) && !isCompleteStatus(status) && !isCancelledStatus(status) && !!normalized;
};

const getStatusBadge = (status) => {
  if (isFailedStatus(status)) {
    return <span className="status-badge status-failed">Failed</span>;
  }
  if (isRunningStatus(status)) {
    return <span className="status-badge status-running">Running</span>;
  }
  if (isProcessingStatus(status)) {
    return <span className="status-badge status-processing">Running</span>;
  }
  return null;
};

const formatReportDate = (dateString, options) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', options || {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
};

export {
  normalizeStatus,
  isFailedStatus,
  isRunningStatus,
  isProcessingStatus,
  isCompleteStatus,
  isCancelledStatus,
  isInProgressStatus,
  getStatusBadge,
  formatReportDate
};
